export default {
  'pointCard.title': '集點卡',
  'pointCard.welcome': '歡迎參加各活動獲得集點卡',
  'pointCard.my_card': '我的集點卡',
  'pointCard.all_events': '所有活動',
  'pointCard.event_period': '活動期間',
  'pointCard.exchange_period': '兌換期限',
  'pointCard.exchange_period.no_limit': '兌換期限 無期限',
  'pointCard.exchange_period.date': '兌換期限 {date}',
  'pointCard.exchange_period.date_range': '兌換期限 {start} ~ {end}',
  'pointCard.exchange_period.points_expired_in_this_month': '本月到期 {n} 點',
  'pointCard.exchange_period.points_expired_in_this_year': '今年到期 {n} 點',
  'pointCard.exchange_period.due_year': '{due} 年',
  'pointCard.exchange_period.due_month': '{due} 個月',
  'pointCard.exchange_period.due_day': '{due} 天',
  'pointCard.exchange_period.3': '獲得點數後 次 {due} 年底',
  'pointCard.exchange_period.4': '獲得點數後 {due} 內可以兌換',
  'pointCard.exchange_period.5': '由最後一次獲得點數起算效期',
  'pointCard.exchange_period.6': '由第一次獲得點數起算效期',
  'pointCard.specified_store': '限定門店',
  'pointCard.join': '加入',
  'pointCard.event_end': '此活動已結束',
  'pointCard.add_success': '成功加入我的集點卡',
  'pointCard.event_deadline': '活動期限',
  'pointCard.detail': '詳情',
} as Record<string, string>;
